import { IState } from '../../../store';

export const selectOfferId = (state: IState): number => {
  return state.offerData.offer.id;
};
